/**
 * Container for responsive div
 */

import React from 'react';
import EventListener from 'fbjs/lib/EventListener';
import PropTypes from 'prop-types';

class KeyBox extends React.Component {

  static propTypes = {
    enabled: PropTypes.bool,
    onPressESC: PropTypes.func,
    onPressLeftArrow: PropTypes.func,
    onPressRightArrow: PropTypes.func
  };

  static defaultProps = {
    enabled: true,
    onPressESC: () => {},
    onPressLeftArrow: () => {},
    onPressRightArrow: () => {}
  };

  componentDidMount() {
    if (this.props.enabled) {
      this._attachKeyListener();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this._detachKeyListener();
    if (this.props.enabled) {
      this._attachKeyListener();
    }
  }

  render() {
    return this.props.children ? React.Children.only(this.props.children) : null;
  }

  componentWillUnmount() {
    this._detachKeyListener();
  }

  _attachKeyListener = () => {
    this._onKeyUpListener = EventListener.listen(window, 'keyup', this._onKeyUp);
  };

  _detachKeyListener = () => {
    if (this._onKeyUpListener) {
      this._onKeyUpListener.remove();
      this._onKeyUpListener = null;
    }
  };

  _onKeyUp = (evt) => {
    evt = evt || window.event;

    switch (evt.keyCode) {
      case 27:
        this.props.onPressESC();
        break;
      case 37:
        this.props.onPressLeftArrow();
        break;
      case 39:
        this.props.onPressRightArrow();
        break;
      default:
        break;
    }
  };

}

export default KeyBox;



// WEBPACK FOOTER //
// ./src/components/KeyBox.js